module.exports = __webpack_public_path__ + "static/media/WebsiteMockup.92a10c54.png";